module.exports = __webpack_public_path__ + "img/ring_y_skip_0_0@2x.59693fde.png";